import { render } from "./RolePermissions.vue?vue&type=template&id=87376092&ts=true"
import script from "./RolePermissions.vue?vue&type=script&lang=ts"
export * from "./RolePermissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Roles/Permissions/RolePermissions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87376092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87376092', __exports__)) {
    api.reload('87376092', __exports__)
  }
  
  module.hot.accept("./RolePermissions.vue?vue&type=template&id=87376092&ts=true", () => {
    api.rerender('87376092', render)
  })

}


export default __exports__